import script from "./AddRoles.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddRoles.vue?vue&type=script&setup=true&lang=ts"

import "./AddRoles.vue?vue&type=style&index=0&id=20ae495b&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ae495b"]])

export default __exports__